import classNames from "classnames"
import "./HarvestClock.scss"

type HarvestClockProps = {
  className?: string
  state?: "clock" | "warning" | "hidden"
} & React.ComponentPropsWithoutRef<"div">

function HarvestClock({
  className,
  state = "clock",
  ...props
}: HarvestClockProps) {
  return (
    <div className={className} {...props}>
      <div className={classNames("HarvestClock", `HarvestClock--${state}`)}>
        <div className="HarvestClock__face">
          <div className="HarvestClock__hand HarvestClock__hand--hour" />
          <div className="HarvestClock__hand HarvestClock__hand--minute" />
          <div className="HarvestClock__center" />
        </div>
      </div>
    </div>
  )
}

export default HarvestClock
